import React, { useState, useEffect } from 'react';
import { createVocabulary, updateVocabulary } from '../../api/api';
import { VocabularyWord } from '../../types';

interface Props {
  topicId: string;
  initialData?: VocabularyWord | null;
  onSuccess: () => void;
}

const VocabularyForm: React.FC<Props> = ({ topicId, initialData, onSuccess }) => {
  const isEditing = !!initialData;

  // State quản lý các trường của form
  const [word, setWord] = useState('');
  const [definition, setDefinition] = useState('');
  const [type, setType] = useState('noun');
  const [ipa, setIpa] = useState('');
  const [example1, setExample1] = useState('');
  const [example2, setExample2] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Tự động điền dữ liệu vào form khi ở chế độ Edit
  useEffect(() => {
    if (isEditing && initialData) {
      setWord(initialData.word);
      setDefinition(initialData.definition);
      setType(initialData.type);
      setIpa(initialData.ipa);
      setExample1(initialData.example1);
      setExample2(initialData.example2);
    } else {
      // Reset form về trạng thái trống khi mở ở chế độ Create
      setWord('');
      setDefinition('');
      setType('');
      setIpa('');
      setExample1('');
      setExample2('');
    }
  }, [initialData, isEditing]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const vocabData = { word, definition, type, ipa, example1, example2, topicName: '', audioUrl: '', imgUrl: '' };

    try {
      if (isEditing && initialData) {
        // Gọi API Update nếu đang ở chế độ Edit
        await updateVocabulary(initialData.id, { ...vocabData, topicId } as VocabularyWord);
      } else {
        // Gọi API Create nếu đang ở chế độ tạo mới
        await createVocabulary({ ...vocabData, topicId } as VocabularyWord);
      }
      onSuccess(); // Báo hiệu thành công để component cha xử lý
    } catch (err) {
      setError('Failed to save vocabulary. Please try again.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="creation-form">
      <input type="text" placeholder="Word (e.g., chaotic)" value={word} onChange={(e) => setWord(e.target.value)} required disabled={isLoading} />
      <input type="text" placeholder="Type (e.g., noun, verb)" value={type} onChange={(e) => setType(e.target.value)} required disabled={isLoading} />
      <input type="text" placeholder="IPA (e.g., /keɪˈɒtɪk/)" value={ipa} onChange={(e) => setIpa(e.target.value)} disabled={isLoading} />
      <textarea placeholder="Definition" rows={3} value={definition} onChange={(e) => setDefinition(e.target.value)} required disabled={isLoading}></textarea>
      <textarea placeholder="Example 1" rows={2} value={example1} onChange={(e) => setExample1(e.target.value)} required disabled={isLoading}></textarea>
      <textarea placeholder="Example 2 (optional)" rows={2} value={example2} onChange={(e) => setExample2(e.target.value)} disabled={isLoading}></textarea>

      {error && <p className="error-message">{error}</p>}

      <button type="submit" className="btn" disabled={isLoading}>
        {isLoading ? 'Saving...' : (isEditing ? 'Save Changes' : 'Add Word')}
      </button>
    </form>
  );
};

export default VocabularyForm;